import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';
import { generatePath } from 'react-router';
import styled from 'styled-components';

import { RelatedPage } from '@sorare/core/src/atoms/navigation/RelatedPage';
import { FOOTBALL_CLUBS_SLUG } from '@sorare/core/src/constants/__generated__/routes';

import { TeamPicture } from '#src/components/club/TeamPicture/index.tsx';

import type { RelatedClub_club } from './__generated__/index.graphql.ts';

type Props = {
  club: RelatedClub_club;
};

const ClubLogo = styled(TeamPicture)`
  max-height: 80px;
  margin-right: 40px;
`;

export const RelatedClub = ({ club }: Props) => {
  return (
    <RelatedPage
      title={club.name}
      subtitle={club.domesticLeague ? club.domesticLeague.displayName : ''}
      link={generatePath(FOOTBALL_CLUBS_SLUG, { slug: club.slug })}
    >
      <ClubLogo team={club} />
    </RelatedPage>
  );
};

RelatedClub.fragments = {
  club: gql`
    fragment RelatedClub_club on Club {
      slug
      name
      domesticLeague {
        slug
        displayName
      }
      ...TeamPicture_team
    }
    ${TeamPicture.fragments.team}
  ` as TypedDocumentNode<RelatedClub_club>,
};
